import {styled} from 'styled-components';

import {Custom} from '@shared_web/lib/react';

import {MAIN_COLOR} from '@mavismart_frontend/lib/constants';

interface TitleProps {
  name: string | React.ReactNode;
}

export const Title: Custom<TitleProps, 'div'> = props => {
  const {name, ...rest} = props;
  return <Name {...rest}>{name}</Name>;
};

Title.displayName = 'Title';

const Name = styled.div`
  font-size: 26px;
  line-height: 26px;
  color: ${MAIN_COLOR};
  text-align: center;
  margin:  16px 0 16px 0;
`;
